/**
 * --------------------------------------------------------------------------
 * Basic Modules: Truncate.js
 * --------------------------------------------------------------------------
 */

import Util from "./util";

/**
 * ------------------------------------------------------------------------
 * Constants
 * ------------------------------------------------------------------------
 */

const $                 = window.jQuery;
const DEBUG             = false;
const NAME              = 'truncate';
const DATA_KEY          = NAME;
const EVENT_KEY         = `.${DATA_KEY}`;
const LOG_KEY           = `[${NAME}]`;

const Default = {
    scrollPollInterval  : 250,
    scrollThreshold     : 5,
    lines               : 1,
};

const Event = {
    RESIZE              : `resize${EVENT_KEY}`,
    SCROLL              : `scroll${EVENT_KEY}`,
};

const ClassName = {
    READ_MORE              : 'read-more',
};

const Selector = {
    TOGGLE              : '.js-truncate',
    READ_MORE           : '.read-more'
};

const Regex = {
  COMMENT_PSEUDO_COMMENT_OR_LT_BANG : new RegExp(
    '<!--[\\s\\S]*?(?:-->)?'
    + '<!---+>?'  // A comment with no body
    + '|<!(?![dD][oO][cC][tT][yY][pP][eE]|\\[CDATA\\[)[^>]*>?'
    + '|<[?][^>]*>?',  // A pseudo-comment
    'g')
};

const DataAttr = {
};

class Truncate {

    constructor(element, config) {

        DEBUG && console.log(LOG_KEY, 'Init');

        this.resizeTimeout = null;
        this.scrollInitialized = false;
        this.lineHeight = null;

        this._element = element;
        this._config  = this._getConfig(config);

        if ($(this._element).attr('title')) {
            $(this._element).text($(this._element).attr('title'))
        }
        if (! $(this._element).attr('data-link') && $(this._element).find(ClassName.READ_MORE).length > 0) {
            $(this._element).attr('data-link', $(this._element).find(ClassName.READ_MORE)[0].outerHTML);
        }

        this.link = $(this._element).attr('data-link');
        this._run();

        this._addEventListeners();
    }

    _run() {
        let lineHeight = window.lineHeight(this._element);
        let $element = $(this._element);


        if ($element.height() > this._config.lines * lineHeight) {
            let title = $element.html().replace(Regex.COMMENT_PSEUDO_COMMENT_OR_LT_BANG, "").trim();
            let titleAttr = title.replace(/<[^>]*>?/gm, '');

            if (! $element.attr("title")) {
                $element.attr('title', titleAttr);
            }

            let words = $element.attr('title').split(' ');
            let str = '';
            let prevStr = '';
            $element.text('');
            for (let i = 0, len = words.length; i < len; i++) {
                if ($element.height() > this._config.lines * lineHeight) {
                    $element.html(prevStr.trim() + '&hellip; ' + (this.link ? ' ' + this.link : ''));
                    break;
                }
                prevStr = str;
                str += words[i] + ' ' ;
                $element.html(str.trim() + '&hellip; ' + (this.link ? ' ' + this.link : ''));
            }

            if ($element.height() > this._config.lines * lineHeight) {
                $element.html(prevStr.trim() + '&hellip; ' + (this.link ? ' ' + this.link : ''));
            }
        }
    }

    destroy() {
        $(this._element).off(EVENT_KEY);
        $.removeData(this._element, DATA_KEY);
        this._element = null;
    }

    // Private

    _getConfig(config) {
        return {
            ...Default,
            ...config
        };
    }

    _isMobile() {
        return Util.viewport === 'mobile';
    }

    _addEventListeners() {
        $(window).on(Event.RESIZE, (event) => this._handleWindowResize(event));
        //this._handleScroll();
    }

    /**
     * Handle the resizing of the window
     * @private
     */
    _handleWindowResize() {

        if (this.resizeTimeout) return;

        // do stuff when window is resized.
        this._run();

        this.resizeTimeout = setTimeout(() => {
            this.resizeTimeout = null;
        }, 500);
    }

    _handleScroll() {

        if (this.scrollInitialized === false) {

            let didScroll = false;
            let lastScrollTop = 0;

            this.scrollInitialized = true;

            $(window).on(Event.SCROLL, () => {
                didScroll = true;
            });

            // Polling the scrolling and run hasScrolled() and reset didScroll status
            setInterval(() => {
                if (didScroll) {
                    hasScrolled(); // function where stuff gets done.
                    didScroll = false;
                }
            }, this._config.scrollPollInterval);

            const hasScrolled = () => {
                let scrollTop = $(window).scrollTop();
                let distance  = Math.abs(scrollTop - lastScrollTop);

                if (distance <= this._config.scrollThreshold) { // delta
                    // Don't do anything when scrolling doesn't exceed scrolling threshold
                    return;
                }

                // Do stuff here:
                if (scrollTop > 0) {}

                // End stuff here

                lastScrollTop = scrollTop;
            }
        }
    }

    // Static

    /**
     * Convenient static method to initiate the module.
     *
     * @param config
     * @param selector
     */
    static bind (config, selector) {
        Truncate._jQueryInterface.call($(selector || Selector.TOGGLE), config);
    }

    /**
     * jQuery Interface
     * @param config
     * @returns {*}
     */
    static _jQueryInterface(config) {
        return this.each(function() {
            const $this = $(this);
            let data    = $this.data(DATA_KEY);
            let _config = {
                ...Default,
                ...$this.data(),
                ...typeof config === 'object' && config ? config : {}
            };

            if (!data) {
                data = new Truncate(this, _config);
                $this.data(DATA_KEY, data);
            }

            if (typeof config === 'string') {
                if (typeof data[config] === 'undefined') {
                    throw new TypeError(`No method named "${config}"`);
                }
                data[config]();
            }
        });
    }
}

/**
 * ------------------------------------------------------------------------
 * jQuery
 * ------------------------------------------------------------------------
 */

$.fn[NAME] = Truncate._jQueryInterface;
$.fn[NAME].Constructor = Truncate;


export default Truncate;
